<template>
    <div class="immersive-tour-main">
        <div class="immersive-tour-center">
            <div class="title">{{immersiveTourInfo.title}}</div>
            <div class="desc">{{immersiveTourInfo.desc}}</div>
            <div class="immersive-tour-content">
                <div class="tab">
                    <div class="tab-item" 
                         v-for="item in immersiveTourInfo.tabList" 
                         :key="item.id" 
                         @click="getContentInfo(item.id)" 
                         :class="{'active':contentInfo.id === item.id}">
                        {{item.title}}
                    </div>
                </div>
                
                <!-- 添加过渡效果 -->
                <div class="tab-item-content" :key="contentInfo.id" :class="{'banner-fade-in':contentInfo.id}">
                    <img loading="lazy"  :src="contentInfo.img" alt="">
                    <div class="info">
                        <div class="tab-item-content-title" :class="{'animate':animate}">{{contentInfo.title}}</div>
                        <div class="tab-item-content-desc" :class="{'animate':animate}">{{contentInfo.desc}}</div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import immersiveTour from '/js/experience/activities/immersiveTour.js'
export default {
    data() {
        return {
            immersiveTourInfo: immersiveTour.immersiveTour,
            contentInfo: {},
            animate:false
        }
    },
    mounted() {
        this.getContentInfo(this.immersiveTourInfo.tabList[0].id)
    },
    methods: {
        getContentInfo(id) {
            this.contentInfo = this.immersiveTourInfo.contentList.find(item => item.id === id)
            this.animate = true
        }
    }
}
</script>

<style scoped lang="scss">
/* 新增淡入淡出动画 */
@import '/style/pc/common/fadeIn.scss';
@import '/style/pc/common/animate.scss';
.immersive-tour-main {
    width: 100%;
    .immersive-tour-center {
        width: 75rem; 
        margin: 0 auto;
        .title {
            color: #09080D;
            text-align: center;
            font-size: 2.5rem; 
            font-weight: 700;
            line-height: 1.2;
            text-transform: capitalize;
            margin-bottom: 0.5rem;
            margin-top: 5.625rem; 
            font-family: Butler;

        }
        .desc {
            color: #09080D;
            text-align: center;
            font-family: Inter;
            font-size: 1.25rem; 
            font-weight: 400;
            line-height: 1.5; 
            margin-bottom: 2.5rem;
        }
        .immersive-tour-content {
            .tab {
                display: flex;
                justify-content: center;
                cursor: pointer;
                background: #F4F4F6;
                .tab-item {
                    color: #09080D;
                    text-align: center;
                    font-family: Inter;
                    font-size: 1.25rem; 
                    font-weight: 500;
                    line-height: 1.2;
                    text-transform: capitalize;
                    padding: 0.5625rem 1.5rem; 
                    width: 20%;
                    height: 4rem;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                }
                .tab-item:first-child {
                    border-radius: 0.125rem 0 0 0;
                }
                .tab-item:last-child {
                    border-radius: 0 0.125rem 0 0;
                }
                .active, .tab-item:hover {
                    color: #FFF;
                    text-align: center;
                    font-family: Inter;
                    font-size: 1.25rem; 
                    font-weight: 500;
                    line-height: 1.2;
                    text-transform: capitalize;
                    background: #09080D;
                }
            }
            .tab-item-content {
                background: #F4F4F6;
                img {
                    width: 100%;
                    height: 40.625rem; 
                }
                .info {
                    padding: 1.25rem;
                    border-radius: 0 0 0.125rem 0.125rem;
                    .tab-item-content-title {
                        color: #141418;
                        font-feature-settings: 'liga' off, 'clig' off;
                        font-family: Inter;
                        font-size: 1.125rem;
                        font-weight: 500;
                        line-height: 1.2; 
                        text-transform: capitalize;
                    }
                    .tab-item-content-desc {
                        color: #09080D;
                        font-family: Inter;
                        font-size: 1rem;
                        font-weight: 300;
                        line-height: 1.5; 
                        margin-top: 1.25rem; 
                    }
                }
            }
        }
    }
}

</style>